import axiosInstance from "../../config"; //axios instance

// async funtion for make smoother and faster without waiting of acknowledgement
export const tradingService = async (token, newPauseState) => {
  try {
    // Calling api here
    const response = await axiosInstance.post(
      "/ui/trading-pause",
      { pause: newPauseState },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return {
      data: response.data, //return data response
      status: response.status, //return status response
    };
  } catch (error) {
    return {
      error: true,
      message: error.response?.data || error.message,
      status: error.response?.status || 500,
    };
  }
};
